export class AmpUserInfoPayload {
  constructor(public key: string, public value: string) { }
}

export class AmpUserInfo {
  email: string;
  lastName: string;
  middleName: string;
  firstName: string;
  mobileNo: string;

  constructor(email: string, lastName: string, middleName: string, firstName: string, mobileNo: string) {
    this.email = email;
    this.lastName = lastName;
    this.middleName = middleName;
    this.firstName = firstName;
    this.mobileNo = mobileNo;
  }
}
